<script>
const { VUE_APP_API_HOST } = process.env

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
})

export default {
  methods: {
    listReportSchedules() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/report-schedules`, authHeaders())
        .then(res => res, err => err)
    },

    createReportSchedule(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/report-schedules`, body, authHeaders())
        .then(res => res, err => err)
    },

    updateReportSchedule(id, body) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/report-schedules/${id}`, body, authHeaders())
        .then(res => res, err => err)
    },

    deleteReportSchedule(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/report-schedules/${id}`, authHeaders())
        .then(res => res, err => err)
    },

    sendReportScheduleNow(id) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/report-schedules/${id}/send-now`, {}, authHeaders())
        .then(res => res, err => err)
    },

    listReportDeliveries(page) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/report-deliveries?page=${page || 1}`, authHeaders())
        .then(res => res, err => err)
    },

    getReportDeliveryPdfUrl(deliveryId, pdfId) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/report-deliveries/${deliveryId}/pdfs/${pdfId}`, authHeaders())
        .then(res => res, err => err)
    }
  }
}
</script>
